import { LucideProps } from 'lucide-react';

export const Linkedin = (props: LucideProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5889_38863)">
      <path
        d="M23.1707 0H2.71914C1.73945 0 0.947266 0.773438 0.947266 1.72969V22.2656C0.947266 23.2219 1.73945 24 2.71914 24H23.1707C24.1504 24 24.9473 23.2219 24.9473 22.2703V1.72969C24.9473 0.773438 24.1504 0 23.1707 0ZM8.06758 20.4516H4.50508V8.99531H8.06758V20.4516ZM6.28633 7.43438C5.14258 7.43438 4.21914 6.51094 4.21914 5.37187C4.21914 4.23281 5.14258 3.30937 6.28633 3.30937C7.42539 3.30937 8.34883 4.23281 8.34883 5.37187C8.34883 6.50625 7.42539 7.43438 6.28633 7.43438ZM21.3988 20.4516H17.841V14.8828C17.841 13.5562 17.8176 11.8453 15.9895 11.8453C14.1379 11.8453 13.8566 13.2937 13.8566 14.7891V20.4516H10.3035V8.99531H13.716V10.5609H13.7629C14.2363 9.66094 15.3988 8.70938 17.1285 8.70938C20.7332 8.70938 21.3988 11.0813 21.3988 14.1656V20.4516Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5889_38863">
        <rect width="24" height="24" fill="white" transform="translate(0.947266)" />
      </clipPath>
    </defs>
  </svg>
);
